import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageComponent } from 'app/components/page/PageComponent';

@Component({
  templateUrl: './unauthorised-page.component.html',
  styleUrls: ['./unauthorised-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorisedPageComponent extends PageComponent {}
